export const UMB_SORT_CHILDREN_OF_MODAL_ALIAS = 'Umb.Modal.SortChildrenOf';
